/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, date: NonNullable<unknown> }} Practice_HistoryInputs */



/**
* | output |
* | --- |
* | "Practised {count} times · last on {date}" |
*
* @param {Practice_HistoryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_history = /** @type {((inputs: Practice_HistoryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_HistoryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.count} keer geoefend · laatst ${i?.date}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} fois travaillé · dernière fois le ${i?.date}`)
	return /** @type {LocalizedString} */ (`Practised ${i?.count} times · last on ${i?.date}`)
});